interface PageHeroProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
}

export const PageHero = ({ eyebrow, title, subtitle }: PageHeroProps) => (
  <section className="bg-hero text-primary-foreground py-20 md:py-28">
    <div className="container max-w-4xl text-center">
      {eyebrow && (
        <p className="uppercase tracking-widest text-secondary text-sm font-semibold mb-4">{eyebrow}</p>
      )}
      <h1 className="heading-xl mb-6">{title}</h1>
      {subtitle && <p className="text-lg md:text-xl text-primary-foreground/85 leading-relaxed max-w-2xl mx-auto">{subtitle}</p>}
    </div>
  </section>
);
